var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgQuestion = function SvgQuestion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#07818C",
    fillRule: "evenodd",
    d: "M10 0C4.477 0 0 4.477 0 10s4.477 10 10 10 10-4.477 10-10S15.523 0 10 0M2 10a8 8 0 1 0 16 0 8 8 0 0 0-16 0",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#07818C",
    d: "M9.19 14.68a.82.82 0 1 1 1.64 0 .82.82 0 0 1-1.64 0M10.283 4.5c2.955.12 4.235 3.098 2.495 5.32-.46.547-1.193.908-1.565 1.378a1.6 1.6 0 0 0-.334.747c-.082.446-.417.819-.87.819s-.83-.368-.81-.821c.026-.57.108-1.057.372-1.434.361-.547 1.095-.876 1.554-1.237 1.347-1.237.996-2.977-.842-3.12-.619 0-1.164.349-1.444.866-.215.398-.566.787-1.02.787-.452 0-.83-.373-.72-.812A3.294 3.294 0 0 1 10.284 4.5"
  })));
};
export default SvgQuestion;